module.exports = __webpack_public_path__ + "img/filtros.378bce82.svg";